export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/ArrowRight.a54241c0.svg","height":7,"width":14};